<cmps-dialog
    class="cmps-gp-action-picker  cmps-cdk-max-w-640px cmps-cdk-w-100pct cmps-cdk-border-width-2p cmps-cdk-border-solid {{
        _data?.groupedAction?.action?.actionPickerBorderColor
    }}"
>
    <cmps-dialog-body>
        <div class="cmps-cdk-d-flex cmps-cdk-align-items-center">
            <div
                class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-cg-0dot5 cmps-cdk-flex-grow-1"
            >
                <cmps-icon
                    class="ap-header-icon {{
                        _data?.groupedAction?.action?.iconFill
                    }}"
                    [svgIcon]="_data?.groupedAction?.action?.icon"
                ></cmps-icon>
                <div class="cmps-cdk-font-size-16p cmps-cdk-font-weight-600">
                    {{ _data?.groupedAction?.action?.label | translate }}
                </div>
            </div>
            <div>
                <button
                    type="button"
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [attr.aria-label]="_i18n._11317_CLOSE | translate"
                    [cmpsTooltipTrigger]="_i18n._11317_CLOSE | translate"
                    (click)="_dialogRef.close()"
                >
                    <cmps-icon svgIcon="close"></cmps-icon>
                </button>
            </div>
        </div>
        <div class="cmps-cdk-font-size-14p">
            {{ _data?.groupedAction?.action?.actionPickerLabel | translate }}
        </div>

        <div class="cmps-cdk-py-1">
            <div class="ap-coach-list">
                <a
                    class="ap-coach-card"
                    *ngFor="let i of _data?.groupedAction?.actionPickerItems"
                    [routerLink]="i.linkRouterCommands?.[0]"
                    [queryParams]="i.linkRouterCommands?.[1]?.queryParams"
                    [attr.aria-label]="i.label"
                    (click)="_dialogRef.close()"
                >
                    <div class="ap-coach-card__header">
                        <div class="ap-coach-card__title">
                            <span class="ap-coach-card__metric">{{
                                i.label
                            }}</span>
                            <span
                                class="ap-coach-card__sub-label"
                                *ngIf="i.subLabel"
                                >{{ i.subLabel }}</span
                            >
                        </div>
                        <cmps-icon
                            svgIcon="chevron-right"
                            class="ap-coach-card__chevron"
                            aria-hidden="true"
                        ></cmps-icon>
                    </div>

                    <!-- Coach: flat stats -->
                    <div
                        class="ap-coach-card__stats"
                        *ngIf="i.metrics === null"
                    >
                        <div class="ap-coach-card__stat">
                            <span class="ap-coach-card__stat-label">{{
                                _i18n._11319_ACTUAL | translate
                            }}</span>
                            <span class="ap-coach-card__stat-value">{{
                                i.actual != null
                                    ? (i.actual | cmpsNumber: '1.0-1')
                                    : '—'
                            }}</span>
                        </div>
                        <div class="ap-coach-card__stat">
                            <span class="ap-coach-card__stat-label">{{
                                _i18n._11320_TARGET | translate
                            }}</span>
                            <span class="ap-coach-card__stat-value">{{
                                i.target != null
                                    ? (i.target | cmpsNumber: '1.0-1')
                                    : '—'
                            }}</span>
                        </div>
                        <div class="ap-coach-card__stat">
                            <span class="ap-coach-card__stat-label">{{
                                _i18n._11321_PCT_TO_TARGET | translate
                            }}</span>
                            <span
                                class="ap-coach-card__stat-value"
                                [style.color]="i.targetColour"
                                >{{
                                    i.percentToTarget != null
                                        ? (i.percentToTarget | cmpsSdpPercent)
                                        : '—'
                                }}</span
                            >
                        </div>
                        <div class="ap-coach-card__stat">
                            <span class="ap-coach-card__stat-label">{{
                                _i18n._11322_30_DAY_FORECAST | translate
                            }}</span>
                            <span class="ap-coach-card__stat-value">{{
                                i.projectionResult30 != null
                                    ? (i.projectionResult30 | cmpsSdpPercent)
                                    : '—'
                            }}</span>
                        </div>
                    </div>

                    <!-- Non-coach: per-metric rows -->
                    <ng-container *ngIf="i.metrics !== null">
                        <!-- Fallback when no metrics are available yet -->
                        <div
                            class="ap-coach-card__stats"
                            *ngIf="i.metrics.length === 0"
                        >
                            <div class="ap-coach-card__stat">
                                <span class="ap-coach-card__stat-label">{{
                                    _i18n._11319_ACTUAL | translate
                                }}</span>
                                <span class="ap-coach-card__stat-value">—</span>
                            </div>
                            <div class="ap-coach-card__stat">
                                <span class="ap-coach-card__stat-label">{{
                                    _i18n._11323_GOAL | translate
                                }}</span>
                                <span class="ap-coach-card__stat-value">—</span>
                            </div>
                            <div class="ap-coach-card__stat">
                                <span class="ap-coach-card__stat-label">{{
                                    _i18n._11324_PCT_TO_GOAL | translate
                                }}</span>
                                <span class="ap-coach-card__stat-value">—</span>
                            </div>
                            <div class="ap-coach-card__stat">
                                <span class="ap-coach-card__stat-label">{{
                                    _i18n._11325_EXPIRY | translate
                                }}</span>
                                <span class="ap-coach-card__stat-value">—</span>
                            </div>
                        </div>
                        <ng-container
                            *ngFor="let m of i.metrics; trackBy: _trackByMetric"
                        >
                            <div class="ap-card__metric-name">
                                {{ m.metricName }}
                            </div>
                            <div class="ap-coach-card__stats">
                                <div class="ap-coach-card__stat">
                                    <span class="ap-coach-card__stat-label">{{
                                        _i18n._11319_ACTUAL | translate
                                    }}</span>
                                    <span class="ap-coach-card__stat-value">{{
                                        m.actual != null
                                            ? (m.actual | cmpsNumber: '1.0-1')
                                            : '—'
                                    }}</span>
                                </div>
                                <div class="ap-coach-card__stat">
                                    <span class="ap-coach-card__stat-label">{{
                                        _i18n._11323_GOAL | translate
                                    }}</span>
                                    <span class="ap-coach-card__stat-value">{{
                                        m.goalValue != null
                                            ? (m.goalValue
                                              | cmpsNumber: '1.0-1')
                                            : '—'
                                    }}</span>
                                </div>
                                <div class="ap-coach-card__stat">
                                    <span class="ap-coach-card__stat-label">{{
                                        _i18n._11324_PCT_TO_GOAL | translate
                                    }}</span>
                                    <span
                                        class="ap-coach-card__stat-value"
                                        [style.color]="m.goalColour"
                                        >{{
                                            m.percentToGoal != null
                                                ? (m.percentToGoal
                                                  | cmpsSdpPercent)
                                                : '—'
                                        }}</span
                                    >
                                </div>
                                <div class="ap-coach-card__stat">
                                    <span class="ap-coach-card__stat-label">{{
                                        _i18n._11325_EXPIRY | translate
                                    }}</span>
                                    <span
                                        class="ap-coach-card__stat-value"
                                        [class.cmps-cdk-color-red-100]="
                                            m.isExpired
                                        "
                                        >{{
                                            m.estimatedCompletionDate != null
                                                ? (m.estimatedCompletionDate
                                                  | cmpsDate: 'MMM.-dd-yyyy')
                                                : '—'
                                        }}</span
                                    >
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </a>
            </div>
        </div>

        <div
            class="cmps-cdk-d-flex cmps-cdk-color-green-100 cmps-cdk-justify-content-flex-end"
        >
            <button
                class="focus:not:focus-visible:cmps-cdk-outline-0 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-border-width-0p cmps-cdk-h-45px cmps-cdk-w-115px cmps-cdk-color-blue-100 cmps-cdk-bg-color-transparent cmps-cdk-p-0 cmps-cdk-cursor-pointer"
                type="button"
                (click)="_dialogRef.close()"
            >
                <div class="cmps-cdk-font-size-14p">
                    {{ _i18n._11318_CANCEL | translate }}
                </div>
            </button>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
